import './style.scss';
import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';

document.addEventListener('DOMContentLoaded', () => {
    if (hoyry_mapbox.access_token == '') {
        return;
    }
    const map_els = document.querySelectorAll('div.wp-block-hoyry-map');
    for (const map_el of map_els) {
        let cluster = {};
        let marker_el = map_el.querySelector('.marker');
        marker_el.style.display = '';

        const markerHeight = parseInt(map_el.dataset.mh);
        const markerWidth = parseInt(map_el.dataset.mw);
        const heightOffset = markerHeight / 2;
        const widthOffset = markerWidth / 2;
        const popupOffsets = {
            'top': [0, 0],
            'top-left': [0, 0],
            'top-right': [0, 0],
            'bottom': [0, -markerHeight],
            'bottom-left': [widthOffset, -markerHeight],
            'bottom-right': [-widthOffset, -markerHeight],
            'left': [widthOffset, -heightOffset],
            'right': [-widthOffset, -heightOffset]
        };

        const markers = [...map_el.querySelectorAll('div.wp-block-hoyry-map-marker')].map((marker) => {
            if (map_el.dataset.cluster != 'true') {
                return new mapboxgl.Marker({
                    element: marker_el.cloneNode(true),
                    anchor: 'bottom',
                }).setLngLat([marker.dataset.lng, marker.dataset.lat]).setPopup(new mapboxgl.Popup({anchor: map_el.dataset.popup, offset: popupOffsets}).setHTML(marker.innerHTML));
            }
            return {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [marker.dataset.lng, marker.dataset.lat]
                }
            };
        });
        while(map_el.firstChild) map_el.removeChild(map_el.firstChild);

        const el_styles = window.getComputedStyle(map_el);
        const highways = map_el.dataset.highways || el_styles.getPropertyValue('--hoyry-map-highways') || '#c9ccd8';
        const road = map_el.dataset.road || el_styles.getPropertyValue('--hoyry-map-road') || '#ffffff';
        const canvas = map_el.dataset.canvas || el_styles.getPropertyValue('--hoyry-map-canvas') || '#eee9e2';
        const nature = map_el.dataset.nature || el_styles.getPropertyValue('--hoyry-map-nature') || '#b6e59e';
        const waterway = map_el.dataset.waterWay || el_styles.getPropertyValue('--hoyry-map-waterway') || '#5cace6';
        const water = map_el.dataset.water || el_styles.getPropertyValue('--hoyry-map-water') || '#75cff0';
        const transit = map_el.dataset.transit || el_styles.getPropertyValue('--hoyry-map-transit') || '#b6b8c3';
        const building = map_el.dataset.building || el_styles.getPropertyValue('--hoyry-map-building') || '#dfdcd7';
        const buildingborder = map_el.dataset.buildingBorder || el_styles.getPropertyValue('--hoyry-map-buildingborder') || '#cdcac6';
        const areaborder = map_el.dataset.areaBorder || el_styles.getPropertyValue('--hoyry-map-areaborder') || '#787b8c';
        const text = map_el.dataset.text || el_styles.getPropertyValue('--hoyry-map-text') || '#000000';
        const textborder = map_el.dataset.textBorder || el_styles.getPropertyValue('--hoyry-map-textborder') || '#ffffff';
        const clusterbg = map_el.dataset.clusterBg || el_styles.getPropertyValue('--hoyry-map-clusterbg') || '#ffffff';
        const font = map_el.dataset.font || el_styles.getPropertyValue('--hoyry-map-font') || 'DIN Pro';

        let center = [parseFloat(map_el.dataset.lng) || 26.3671, parseFloat(map_el.dataset.lat) || 65.5018];

        if (markers.length == 1 && map_el.dataset.cluster != 'true' && map_el.dataset.center != 'false') {
            center = markers[0].getLngLat();
        }

        let event = new CustomEvent('hoyry-map-block', {detail: {status: 'loading'}});
        document.dispatchEvent(event);

        const map = new mapboxgl.Map({
            container: map_el,
            style: 'mapbox://styles/mapbox/standard',
            center: center,
            zoom: parseInt(map_el.dataset.zoom) || 9,
            maxZoom: 18,
            accessToken: hoyry_mapbox.access_token,
            language: 'auto',
            scrollZoom: false,
            config: {
                basemap: {
                    showPlaceLabels: map_el.dataset.showPlaces != 'false',
                    showPointOfInterestLabels: map_el.dataset.showPoi != 'false',
                    showRoadLabels: map_el.dataset.showRoad != 'false',
                    showPedestrianRoads: map_el.dataset.showPedestrian != 'false',
                    showTransitLabels: map_el.dataset.showTransit != 'false',
                    show3dObjects: false,
                    colorMotorways: highways,
                    colorTrunks: highways,
                    colorRoads: road,
                    font: font
                }
            }
        });

        map.addControl(new mapboxgl.NavigationControl());
        map.addControl(new mapboxgl.FullscreenControl());

        if (map_el.dataset.cluster != 'true') {
            let bounds = new mapboxgl.LngLatBounds();
            markers.forEach((marker) => {
                marker.addTo(map);
                bounds.extend(marker.getLngLat());
            });
            if (map_el.dataset.center != 'false' && markers.length > 1) {
                map.fitBounds(bounds, {padding: 25});
            }
        }
        else {
            cluster = {
                type: 'FeatureCollection',
                features: markers
            };
        }

        map.once('style.import.load', () => {
            let style = map.getStyle();
            style.imports[0].data.layers = style.imports[0].data.layers.map((layer) => {
                switch(layer.id) {
                    case "land": layer.paint['background-color'] = canvas;
                        break;
                    case "landcover": 
                    case "national-park":
                    case "landuse":
                    case "recreation-polygon":
                        layer.paint['fill-color'] = nature;
                        break;
                    case "road-pedestrian-polygon-fill":
                        layer.paint['fill-color'] = road;
                        break;
                    case "hillshade":
                        layer.paint['fill-opacity'] = 0;
                        break;
                    case "waterway":
                        layer.paint['line-color'] = waterway;
                        break;
                    case "water":
                        layer.paint['fill-color'] = water;
                        break;
                    case "aeroway-polygon":
                        layer.paint['fill-color'] = transit;
                        break;
                    case "aeroway-line":
                        layer.paint['line-color'] = transit;
                        break;
                    case "2d-building":
                        layer.paint['fill-extrusion-color'] = building;
                        break;
                    case "2d-building-outline":
                        layer.paint['line-color'] = buildingborder;
                        break;
                    case "admin-1-boundary-bg":
                    case "admin-0-boundary-bg":
                    case "admin-1-boundary":
                    case "admin-0-boundary":
                        layer.paint['line-color'] = areaborder;
                        break;
                    case "poi-label":
                        layer.paint['text-color'] = text;
                        layer.paint['text-halo-color'] = textborder;
                        break;  
                }
                return layer;
            });
            map.setStyle(style);
        });
        map.once('style.load', () => {
            if (map_el.dataset.cluster == 'true') {
                map.addSource("cluster", {
                    type: 'geojson',
                    data: cluster,
                    cluster: true,
                    clusterRadius: 40,
                });
                map.addLayer({
                    id: "clusters",
                    type: "circle",
                    source: "cluster",
                    filter: ["has", "point_count"],
                    paint: {
                        "circle-color": clusterbg,
                        "circle-radius": [
                            "step",
                            ["get", "point_count"],
                            14,
                            10, 16,
                            100, 18
                        ],
                        "circle-stroke-width": 1,
                        "circle-stroke-color": textborder
                    }
                });
                map.addLayer({
                    id: "cluster-count",
                    type: "symbol",
                    source: "cluster",
                    filter: ["has", "point_count"],
                    layout: {
                        "text-field": "{point_count_abbreviated}",
                        "text-font": [font],
                        "text-size": 12,
                    },
                    paint: {
                        "text-color": text,
                    }
                });
                map.addLayer({
                    id: "singles",
                    type: "circle",
                    source: "cluster",
                    filter: ["!has", "point_count"],
                    paint: {
                        "circle-color": clusterbg,
                        "circle-radius": 4,
                        "circle-stroke-width": 1,
                        "circle-stroke-color": textborder
                    }
                });
            }
        });

        event = new CustomEvent('hoyry-map-block', {detail: {status: 'loaded', obj: map}});
        document.dispatchEvent(event);
        
    };
});
